/**
 * Generated runtime TestId mirror for frontend/src/features/service-accounts/components/MintApiKeyDialog.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

export const MintApiKeyDialogTestIds = {
  btnCopyRawKey: "btn-copy-raw-key",
  btnMintSavedClose: "btn-mint-saved-close",
  mintCopyDisabledMessage: "mint-copy-disabled-message",
  mintDialogTitle: "mint-dialog-title",
  mintForm: "mint-form",
  mintInputExpiry: "mint-input-expiry",
  mintInputName: "mint-input-name",
  mintInputRateLimit: "mint-input-rate-limit",
  mintRawKeyInput: "mint-raw-key-input",
  mintSubmitError: "mint-submit-error",
  mintWarningBanner: "mint-warning-banner"
} as const;
